export default __webpack_public_path__ + "static/media/direct_print.6d09f560.svg";